import Field from "../../../Components/Field";

const General = ({ configs, onChange }) => {
  return (
    <>
      <div className="phishbox-settings__line">
        <div className="p-r-20">
          <Field
            label="Timeout"
            tooltipText="Global request timeout duration in seconds."
            width="92px"
            type="number"
            name="timeout"
            value={configs.timeout}
            onChange={onChange}
            placeholder="30"
          />
        </div>
        <Field
          label="Bulk Mode"
          tooltipText="Bulk processing for higher throughput."
          width="92px"
          type="number"
          name="bulk"
          value={configs.bulk}
          onChange={onChange}
          placeholder="16"
        />
      </div>
    </>
  );
};

export default General;
